export default __webpack_public_path__ + "static/media/equal-to-icon.5d379adc.svg";